import apiClient from "@/app/api/client";
import { replaceParams, taskTypeEndpoints } from "@/app/api/endpoints";
import type {
	CreateTaskTypeRequest,
	ListTaskTypesParams,
	MessageData,
	PaginatedResponse,
	SuccessResponse,
	TaskType,
	UpdateTaskTypeRequest,
} from "../types";

export const taskTypeService = {
	async list(params?: ListTaskTypesParams): Promise<PaginatedResponse<TaskType>> {
		const response = await apiClient.get<PaginatedResponse<TaskType>>(taskTypeEndpoints.list, {
			params,
		});
		return response.data;
	},

	async getById(id: string): Promise<TaskType> {
		const url = replaceParams(taskTypeEndpoints.getById, { id });
		const response = await apiClient.get<SuccessResponse<TaskType>>(url);
		return response.data.data;
	},

	async create(data: CreateTaskTypeRequest): Promise<TaskType> {
		const response = await apiClient.post<SuccessResponse<TaskType>>(
			taskTypeEndpoints.create,
			data
		);
		return response.data.data;
	},

	async update(id: string, data: UpdateTaskTypeRequest): Promise<TaskType> {
		const url = replaceParams(taskTypeEndpoints.update, { id });
		const response = await apiClient.patch<SuccessResponse<TaskType>>(url, data);
		return response.data.data;
	},

	async delete(id: string): Promise<void> {
		const url = replaceParams(taskTypeEndpoints.delete, { id });
		await apiClient.delete<SuccessResponse<MessageData>>(url);
	},
};
